import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { TeacherCard } from "@/pages/TeacherSearch";
import { Heart } from "lucide-react";
import { toast } from "sonner";

export default function Favorites() {
  const [teachers, setTeachers] = useState([]);
  const [favIds, setFavIds] = useState(new Set());
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/favorites");
      setTeachers(data.favorites || []);
      setFavIds(new Set(data.teacher_ids || []));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const toggleFav = async (e, id) => {
    e.preventDefault(); e.stopPropagation();
    try {
      await api.delete(`/favorites/${id}`);
      const s = new Set(favIds); s.delete(id); setFavIds(s);
      setTeachers((t) => t.filter((x) => x.user_id !== id));
      toast.success("Favorilerden çıkarıldı");
    } catch {}
  };

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="mb-10 reveal">
          <span className="text-xs uppercase tracking-widest text-neutral-500 font-medium">Kaydettiklerin</span>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tighter" data-testid="favorites-title">Favorilerim</h1>
        </div>

        {loading ? (
          <div className="text-neutral-500 text-sm">Yükleniyor...</div>
        ) : teachers.length === 0 ? (
          <div className="border border-dashed border-neutral-300 rounded-2xl p-16 text-center">
            <Heart className="mx-auto text-neutral-400" size={32} />
            <div className="mt-4 font-display text-xl">Henüz favori öğretmenin yok</div>
            <p className="mt-2 text-sm text-neutral-500">Öğretmen kartlarındaki yıldıza tıklayarak favorine ekleyebilirsin.</p>
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
            {teachers.map((t) => (
              <TeacherCard key={t.user_id} t={t} isFav={favIds.has(t.user_id)} onToggle={(e) => toggleFav(e, t.user_id)} />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
